var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { styled } from '@material-ui/core/styles';
import { CircularProgress } from '@material-ui/core';
import { flexibleLayoutContainer } from '../styleUtility/flexibleLayout';
import React from 'react';
var Spinner = function (_a) {
    var _b = _a.width, width = _b === void 0 ? '100%' : _b, _c = _a.height, height = _c === void 0 ? 80 : _c, _d = _a.size, size = _d === void 0 ? 32 : _d, color = _a.color, className = _a.className;
    return (React.createElement(Root, { className: className, style: {
            width: width,
            height: height,
        } },
        React.createElement("div", null,
            React.createElement(CircularProgress, { size: size, color: color }))));
};
var Root = styled('div')(__assign(__assign({}, flexibleLayoutContainer({
    direction: 'column',
    alignItems: 'center',
    justifyContent: 'center',
})), { lineHeight: 0 }));
export default Spinner;
